module.exports = __webpack_public_path__ + "media/images/map_icons/MartialArts-84b49990ba3afed51bf32d01f0dbf1cb.svg";